var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size * 1.54,
        height: _vm.size,
        viewBox: "0 0 37 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.17188 15.9999H12.9079L13.0399 14.4999H9.13987C10.0159 12.7479 12.8959 12.4599 12.8959 10.1199C12.8959 8.73994 12.1039 7.88794 10.2079 7.88794C8.21587 7.88794 7.15988 8.90794 7.31588 10.7079H9.01988C8.94787 9.77194 9.31988 9.24394 10.0999 9.24394C10.8679 9.24394 11.1319 9.68794 11.1319 10.2759C11.1319 11.8839 8.49188 12.0399 7.17188 14.6319V15.9999Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d: "M16.0255 15.9999V14.1759H14.2615V15.9999H16.0255Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M20.4365 16.1559C22.3925 16.1559 23.7005 14.9679 23.7005 11.9079C23.7005 8.97994 22.6205 7.88794 20.5685 7.88794C18.6005 7.88794 17.2925 9.06394 17.2925 12.1239C17.2925 15.0519 18.3845 16.1559 20.4365 16.1559ZM20.4845 14.8239C19.5605 14.8239 19.0685 14.2479 19.0685 12.0399C19.0685 9.85594 19.5965 9.21994 20.5085 9.21994C21.4325 9.21994 21.9365 9.79594 21.9365 11.9919C21.9365 14.1999 21.3965 14.8239 20.4845 14.8239Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M29.9821 9.90394H28.2421C28.0381 10.3239 27.8821 10.6719 27.7621 10.9719C27.5341 11.5119 27.4021 11.8839 27.3301 12.0879H27.3061C27.2101 11.7999 27.0661 11.4399 26.7901 10.8879L26.2141 9.80794L24.4141 9.91594L25.9621 12.8919L24.2821 15.9999H26.0341C26.2741 15.5319 26.4061 15.2199 26.6101 14.8119C26.8621 14.2479 27.0541 13.8039 27.1021 13.6239H27.1381C27.2101 13.8639 27.3301 14.1999 27.7141 14.9319L28.3501 16.1079L30.1501 15.9999L28.4821 12.7959L29.9821 9.90394Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("mask", { attrs: { id: "path-2-inside-1", fill: "white" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z"
          }
        })
      ]),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M25 1.3H12C6.09055 1.3 1.3 6.09055 1.3 12C1.3 17.9094 6.09055 22.7 12 22.7H25C30.9094 22.7 35.7 17.9094 35.7 12C35.7 6.09055 30.9094 1.3 25 1.3ZM12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24H25C31.6274 24 37 18.6274 37 12C37 5.37258 31.6274 0 25 0H12Z",
          fill: _vm.color
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12 2.6H25V0H12V2.6ZM2.6 12C2.6 6.80852 6.80852 2.6 12 2.6V0C5.37258 0 0 5.37258 0 12H2.6ZM12 21.4C6.80852 21.4 2.6 17.1915 2.6 12H0C0 18.6274 5.37258 24 12 24V21.4ZM25 21.4H12V24H25V21.4ZM34.4 12C34.4 17.1915 30.1915 21.4 25 21.4V24C31.6274 24 37 18.6274 37 12H34.4ZM25 2.6C30.1915 2.6 34.4 6.80852 34.4 12H37C37 5.37258 31.6274 0 25 0V2.6ZM1.3 12C1.3 6.09055 6.09055 1.3 12 1.3V-1.3C4.65461 -1.3 -1.3 4.65461 -1.3 12H1.3ZM12 22.7C6.09055 22.7 1.3 17.9094 1.3 12H-1.3C-1.3 19.3454 4.65461 25.3 12 25.3V22.7ZM25 22.7H12V25.3H25V22.7ZM35.7 12C35.7 17.9094 30.9094 22.7 25 22.7V25.3C32.3454 25.3 38.3 19.3454 38.3 12H35.7ZM25 1.3C30.9094 1.3 35.7 6.09055 35.7 12H38.3C38.3 4.65461 32.3454 -1.3 25 -1.3V1.3ZM12 1.3H25V-1.3H12V1.3Z",
          fill: _vm.color,
          mask: "url(#path-2-inside-1)"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }